<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useAuthStore } from '@/stores/auth.js';
import {
  fetchCalendarLists,
  fetchCalendarEvents,
  mapGoogleEventToCalendar,
} from '@/api/googleApi.js';

const auth = useAuthStore();
const events = ref(null); // 取得したデータを保持する変数
let ec = null;
let clOptions = null;
let calMap = null;
const calendarElement = ref(null);
const isModalOpen = ref(false); //イベント表示用モーダルの状態
const selectedEvent = ref(null); //選択中のイベント

onMounted(async () => {
  // EventCalendarのモジュールをグローバルから取得
  const { create, Interaction, DayGrid, TimeGrid, ResourceTimeGrid } = window.EventCalendar;
  console.log('Homeマウント開始....');
  if (!auth.providerToken || !calendarElement.value) {
    console.log('Google認証前のユーザーです');
    return;
  }
  if (auth.providerToken && calendarElement.value) {
    try {
      console.log('カレンダーセットアップ開始....');
      // 1. カレンダーIDの一覧を取得
      console.log('カレンダーリスト取得開始...');
      calMap = await fetchCalendarLists(auth.providerToken);
      console.log('カレンダーリスト取得完了');

      // プラグイン
      const clPlugins = [Interaction, TimeGrid, DayGrid, ResourceTimeGrid];

      // カレンダーオプション
      clOptions = {
        plugins: clPlugins,
        view: 'dayGridMonth',
        height: '600px',
        locale: 'ja-JP',
        durableRange: true,
        dayMaxEvents: 1,
        headerToolbar: {
          center: 'title',
        },
        allDayContent: '終日',
        editable: true,
        selectable: true,
        customScrollbars: true,
        columnWidth: 'auto',
        nowIndicator: true,
        resources: [],
        events: [], // ここにデータが入る
        eventClick: handleEventClick,
      };
      ec = create(calendarElement.value, clOptions);

      console.log('カレンダーセットアップ完了');

      fetchAndUpdateCal(calMap);
      /*
      // 表示されている期間を取得
      const start = ec.getView().activeStart;
      const end = ec.getView().activeEnd;

      // --- リソース（列）をカレンダーIDから作成 ---
      clOptions.resources = eventMap?.map((event) => ({
        id: event.id,
        title: event.title, // 表示名
        color: event.color, // カレンダーごとに色を変える（Googleカレンダーの色を使用）
      }));

      // 2. 各IDに対してイベント取得関数を実行し、Promiseの配列を作成（並列処理を行う）
      console.log('カレンダーイベント取得開始...');
      const promises = eventMap?.map((event) => {
        // fetchCalendarEventsはasyncなので、呼び出すだけでPromiseを返します
        return fetchCalendarEvents(auth.providerToken, event.id, start, end);
      });

      // 3. 全ての結果が返ってくるのを待つ
      const allCalendarsData = await Promise.all(promises);
      console.log('カレンダーイベント取得終了');

      // events.value には [ {カレンダー1の予定}, {カレンダー2の予定}, ... ] が入ります
      // events.value = allCalendarsData;

      // 全てのカレンダーの items を一つの配列にフラット化してマッピング
      console.log('マッピング開始...');
      const formattedEvents = allCalendarsData
        .flatMap((data) => data.items || [])
        .map((event) => mapGoogleEventToFullCalendar(event));

      // カレンダーの色を設定（リソースIDとイベントのresourceIdを照合して色を付ける）
      formattedEvents.map((event) => {
        const resource = clOptions.resources.find((r) => r.id === event.resourceId);
        if (resource) {
          event.backgroundColor = resource.color;
        }
      });

      clOptions.events = formattedEvents;
      ec.setOption('resources', clOptions.resources);
      ec.setOption('events', clOptions.events);

      // 最後にeventsにマッピングしたデータをセット（デバッグ用）
      events.value = formattedEvents;
      */
    } catch (error) {
      console.error('データ取得エラー:', error);
    }
  }
  console.log('マッピング終了...');
});

const fetchAndUpdateCal = async (calMap) => {
  if (ec) {
    // 表示されている期間を取得
    const start = ec.getView().activeStart;
    const end = ec.getView().activeEnd;

    // --- リソース（列）をカレンダーIDから作成 ---
    clOptions.resources = calMap?.map((event) => ({
      id: event.id,
      title: event.title, // 表示名
      color: event.color, // カレンダーごとに色を変える（Googleカレンダーの色を使用）
    }));

    // 2. 各IDに対してイベント取得関数を実行し、Promiseの配列を作成（並列処理を行う）
    console.log('カレンダーイベント取得開始...');
    const promises = calMap?.map((event) => {
      // fetchCalendarEventsはasyncなので、呼び出すだけでPromiseを返します
      return fetchCalendarEvents(auth.providerToken, event.id, start, end);
    });

    // 3. 全ての結果が返ってくるのを待つ
    const allCalendarsData = await Promise.all(promises);
    console.log('カレンダーイベント取得終了');

    // events.value には [ {カレンダー1の予定}, {カレンダー2の予定}, ... ] が入ります
    // events.value = allCalendarsData;

    // 全てのカレンダーの items を一つの配列にフラット化してマッピング
    console.log('マッピング開始...');
    const formattedEvents = allCalendarsData
      .flatMap((data) => data.items || [])
      .map((event) => mapGoogleEventToCalendar(event));

    // カレンダーの色を設定（リソースIDとイベントのresourceIdを照合して色を付ける）
    formattedEvents.map((event) => {
      const resource = clOptions.resources.find((r) => r.id === event.resourceId);
      if (resource) {
        event.backgroundColor = resource.color;
      }
    });

    clOptions.events = formattedEvents;
    ec.setOption('resources', clOptions.resources);
    ec.setOption('events', clOptions.events);

    // 最後にeventsにマッピングしたデータをセット（デバッグ用）
    events.value = formattedEvents;
    console.log(events.value);
  }
};

// コンポーネントが破棄されるときにメモリを解放
onBeforeUnmount(() => {
  if (ec && window.EventCalendar && window.EventCalendar.destroy) {
    // インスタンス(ec)を引数として渡して破棄する
    window.EventCalendar.destroy(ec);
    ec = null;
    console.log('Calendar destroyed');
  }
});

const viewDays = () => {
  if (ec) {
    ec.setOption('view', 'resourceTimeGridDay');
  }
};
const viewWeek = () => {
  if (ec) {
    ec.setOption('view', 'resourceTimeGridWeek');
  }
};
const viewMonth = () => {
  if (ec) {
    ec.setOption('view', 'dayGridMonth');
  }
};
const calNext = () => {
  if (ec) {
    ec.next();
    fetchAndUpdateCal(calMap);
  }
};
const calPrev = () => {
  if (ec) {
    ec.prev();
    fetchAndUpdateCal(calMap);
  }
};

// イベントクリック時の処理
const handleEventClick = (info) => {
  console.log(info);
  selectedEvent.value = {
    title: info.event.title,
    start: info.event.start,
    end: info.event.end,
    description: info.event.extendedProps.description,
    color: info.event.backgroundColor,
  };
  isModalOpen.value = true;
};
</script>
<template>
  <h1>Home</h1>
  <div class="calendar-container sm:w-full">
    <div ref="calendarElement"></div>
  </div>
  <div class="mt-4 flex flex-wrap items-center justify-center gap-2" v-if="auth.providerToken">
    <!-- 表示切替 -->
    <div class="flex items-center gap-2 rounded-2xl bg-white p-2 shadow-sm ring-1 ring-gray-200">
      <button
        @click="viewDays"
        class="rounded-xl px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 active:scale-[0.98] transition"
      >
        日
      </button>

      <button
        @click="viewWeek"
        class="rounded-xl px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 active:scale-[0.98] transition"
      >
        週
      </button>

      <button
        @click="viewMonth"
        class="rounded-xl px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 active:scale-[0.98] transition"
      >
        月
      </button>
    </div>

    <!-- 前へ / 次へ -->
    <div class="flex items-center gap-2 rounded-2xl bg-white p-2 shadow-sm ring-1 ring-gray-200">
      <button
        @click="calPrev"
        class="rounded-xl bg-gray-50 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 active:scale-[0.98] transition"
      >
        前へ
      </button>

      <button
        @click="calNext"
        class="rounded-xl bg-gray-50 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 active:scale-[0.98] transition"
      >
        次へ
      </button>
    </div>
  </div>

  <!-- モーダル -->
  <Teleport to="body">
    <div
      v-if="isModalOpen"
      class="fixed inset-0 z-100 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <!-- 背景 -->
        <div
          @click="isModalOpen = false"
          class="fixed inset-0 bg-gray-600/75 backdrop-blur-sm transition-opacity"
          aria-hidden="true"
        ></div>

        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true"
          >&#8203;</span
        >

        <!-- モーダル要素 -->
        <div
          @click.stop
          class="relative z-10 inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full border border-gray-100"
        >
          <div :style="{ backgroundColor: selectedEvent?.color }" class="h-2 w-full"></div>

          <div class="bg-white px-6 pt-5 pb-4">
            <div class="flex justify-between items-start">
              <h3 class="text-xl font-bold text-gray-900" id="modal-title">
                {{ selectedEvent?.title }}
              </h3>
              <button
                @click="isModalOpen = false"
                class="text-gray-400 hover:text-gray-500 transition"
              >
                <span class="text-2xl">&times;</span>
              </button>
            </div>

            <div class="mt-4 space-y-3">
              <div class="flex items-center text-sm text-gray-600">
                <span class="font-semibold w-16">時間:</span>
                <span>{{ selectedEvent?.start?.toLocaleString('ja-JP') }} 〜</span>
              </div>

              <div class="mt-2">
                <p class="text-sm font-semibold text-gray-600">詳細:</p>
                <div
                  class="mt-1 p-3 bg-gray-50 rounded-xl text-sm text-gray-700 whitespace-pre-wrap min-h-[100px]"
                >
                  {{ selectedEvent?.description }}
                </div>
              </div>
            </div>
          </div>

          <div class="bg-gray-50 px-6 py-4 flex flex-row-reverse gap-2">
            <button
              @click="isModalOpen = false"
              type="button"
              class="inline-flex justify-center rounded-xl border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none sm:text-sm transition active:scale-95"
            >
              閉じる
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>
